import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ProgressBarService } from './services/progress-bar/progress-bar.service';

@Injectable()
export class LoadingStatusInterceptor implements HttpInterceptor {
  private _progressBarService = inject(ProgressBarService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith('http')) {
      const requestUrl = new URL(request.url);
      if (
        requestUrl.pathname.indexOf('/api/') === 0 ||
        requestUrl.pathname.indexOf('/identity/api/') === 0 ||
        requestUrl.pathname.indexOf('/customer/api/') === 0
      ) {
        this._progressBarService.show();

        return next.handle(request).pipe(
          // Both solution worked but I chose the first one because it's far less verbose.
          // https://stackoverflow.com/a/50620910/1501861
          // https://stackoverflow.com/questions/47218216/angular-how-to-know-if-request-has-been-cancelled-in-httpclient/49536421#49536421
          finalize(() => {
            // request completes, errors, or is cancelled
            this._progressBarService.hide();
          }),
        );
      }
    }

    return next.handle(request);
  }
}

export const loadingStatusInterceptorProvider = [{ provide: HTTP_INTERCEPTORS, useClass: LoadingStatusInterceptor, multi: true }];
